<template>
  <div>
        <div class="d-flex justify-content-end mb-2 pr-2">
      <!--<b-button
        variant="secondary"
        size="sm"
        @click.prevent="runFetch('all')"
      >
        <feather-icon icon="RefreshCcwIcon" size="16" class="mr-1" />
       Importación general
      </b-button>-->

    </div>
   <div>
    <BaseTable
     ref="table"
      :columns="columns"
      :resource="$data.$constants.RESOURCES.RESOURCE_LOG_IMPORTS"
      :loading="loading"
      :hideTotals="true"
      :hideSearchButton="true"
      :hidePrinterButton="true"
      :hideFilterButton="true"
      :hideImportButton="true"
      :hideToolbar="true"
      :resourceStore="'logImports'"
    >
   <template #cell(status)="{ item }">
      <b-badge :variant="item.status === 'error' ? 'danger' : 'success'">
        {{ item.status }}
      </b-badge>
    </template>
        <template #cell(actions)="data">
        <span>
          <feather-icon
            v-show="data.item.log_migration_lines"
            :id="`popover-target-${data.item.id}`"
            icon="InfoIcon"
            size="18"
            class="text-indigo mr-1"
          />
          <b-popover :target="`popover-target-${data.item.id}`" triggers="hover" placement="top">
            <template #title>LOGS</template>
            <div v-if="Array.isArray(data.item.log_migration_lines)">
              <p v-for="(line, idx) in data.item.log_migration_lines" :key="idx" style="margin-bottom: 0.5em;">
                {{ line.message }}                       
              </p>
            </div>
            <div v-else>
              <p>{{ data.item.log_migration_lines }}</p>              
            </div>
          </b-popover>
        </span>
            <a
              href="#"
              @click.prevent="runFetch(data.item.uuid)"
              title="Relanzar importación"
              class="mr-1 text-indigo"
            >
              <feather-icon
                :icon="'RefreshCcwIcon'"
                size="18"
              />
            </a>
          
      </template>
    </BaseTable>
   </div>
  </div>
</template>

<script>
import BaseTable from "@/components/ui/table/BaseTable.vue";
import LogImportsApi from "@/api/log-imports-api"
import { BBadge } from 'bootstrap-vue';

export default {
  name: 'LogImportsTable',
  components: {
    BaseTable,
    BBadge,
  },
  data() {
    return {
      loading: false,
      columns: [
        {
            label: "Fecha",
            key: "updated_at",
            sortable: true,
        },
        { 
          label: "MENSAJE",
          key: "message",
          sortable: false,
        },  
        {
            label: "ARCHIVOS PROCESADOS",
            key: "files_processed",
            sortable: false,
        },
         { 
          label: "STATUS",
          key: "status",
          sortable: false,
        }, 
        {
          label: "Acciones",
          key: "actions",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { "min-width": "160px" },
        }, 
      ]
    }
  },
  methods:{
    async runFetch(hash){
      this.loading = true;
      try {
        const response = await LogImportsApi.fetchLogImport(hash);
        this.$emit('reload', response.data);
          //Cargar loadData de BaseTable
        this.$refs.table.loadData();
        
      } catch (error) {
        console.error("Error fetching log import:", error);
      } finally {
        this.loading = false;
      }
    }
  }
}

</script>
<style>
hr {
    border-top: 1px solid white !important;
}
</style>